import { useNavigate } from 'react-router-dom';
import { ShowPreferenceRow } from './SettingsPreferenceComponents';
import { useEntityPreference } from './useEntityPreference';

export default function ShowRow({ source, show = source ? { ...source, source } : {}, onOpen, openLabel, description, disabled = false }) {
    const navigate = useNavigate();
    const preference = useEntityPreference('show', show);
    const sourceId = preference.source?.id || show.source?.id;
    const canOpen = Boolean(sourceId || (show.name && show.rssURL));
    const canSave = Boolean(sourceId || show.rssURL || show.appleCollectionId);
    const open = () => {
        if (onOpen) onOpen();
        else if (sourceId) navigate(`/podcast/${encodeURIComponent(sourceId)}`);
        else navigate('/load_podcast', { state: { title: show.name, imageSrc: show.imageURL, rssURL: show.rssURL, ...(show.appleCollectionId ? { appleCollectionId: show.appleCollectionId } : {}) } });
    };
    return <div className="entityPreferenceRowContainer"><ShowPreferenceRow source={{ ...show, source: preference.source || show.source }} description={description ?? show.creator ?? show.author}
        openLabel={openLabel} onOpen={canOpen && !disabled ? open : undefined} showControl={canSave}
        status={preference.status} onStatusChange={preference.change}
        mutation={preference.mutation} onRetry={() => preference.change(preference.mutation.status)} /></div>;
}
